import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiBaseName, ApiReducerPath } from '@Enum/index';
import { customBaseQuery } from '@Utils/api/customBaseQuery';
import { AttendanceProfileResponse } from '@Types/api/profile/AttendanceProfileList';
import {
  RequestListSearchRequest,
  RequestListSearchResponse,
} from '@Types/api/requestList';

export const profileApi = createApi({
  reducerPath: ApiReducerPath.API_PROFILE,
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getProfileAttendances: builder.mutation<
      RequestListSearchResponse<AttendanceProfileResponse>,
      RequestListSearchRequest
    >({
      query: () => ({
        url: `${ApiBaseName.ESS}/hrm-request/attendances`,
        method: 'get',
      }),
    }),
  }),
});

export const { useGetProfileAttendancesMutation } = profileApi;
